import { queryOptions } from '@tanstack/react-query'

import {
  SearchUserParticipantRequest,
  SearchUserParticipantRequestV2,
} from '@/_gql/graphql'

import { gqlFetch, gqlFetchSafe } from '../graphql/fetcher'
import {
  GqlGetUserParticipant,
  GqlSearchUserParticipantV2,
  GqlUserParticipants,
} from './gql'

/** @deprecated */
export function queryGetParticipants(request: SearchUserParticipantRequest) {
  return queryOptions({
    queryKey: ['admin', 'participants', JSON.stringify(request)],

    queryFn: async () => {
      const [res, err] = await gqlFetchSafe({
        query: GqlUserParticipants,
        variables: {
          request: request,
        },
      })

      if (err) {
        return []
      }

      return res.searchUserParticipant
    },
  })
}

export function queryGetParticipantsV2(
  request: SearchUserParticipantRequestV2
) {
  return queryOptions({
    queryKey: ['admin', 'participants', JSON.stringify(request)],

    queryFn: async () => {
      const res = await gqlFetch({
        query: GqlSearchUserParticipantV2,
        variables: {
          request: request,
        },
      })

      return res.searchUserParticipantV2
    },
  })
}

export function queryDetailParticipants(userId: number) {
  return queryOptions({
    queryKey: ['admin', 'detail-participans', String(userId)],
    queryFn: async () => {
      const [res] = await gqlFetchSafe({
        query: GqlGetUserParticipant,
        variables: {
          user_id: userId,
        },
      })

      return res?.getUserParticipant
    },
  })
}
